export default {
  "content": "<path d=\"M12 17.113c-2.785 0-5.041-2.31-5.041-5.165 0-2.401 1.613-4.429 3.78-4.997V3.013c-4.272.62-7.561 4.39-7.561 8.948C3.178 16.958 7.135 21 12 21a8.686 8.686 0 005.28-1.795l-2.722-2.789a5.074 5.074 0 01-2.558.697zM17.041 11.948c0 .956-.252 1.847-.693 2.622l2.722 2.789a9.103 9.103 0 001.752-5.41c0-4.559-3.29-8.316-7.562-8.949v3.938c2.168.581 3.781 2.609 3.781 5.01z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};